var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.board ? _c('v-responsive', [_c('v-card', {
    attrs: {
      "tile": "",
      "elevation": "0"
    }
  }, [_c('v-card-title', {
    staticClass: "tit tit--xs"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v(" 제목: " + _vm._s(_vm.board.subject) + " ")]), _c('v-spacer'), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("작성일자: " + _vm._s(_vm.$dayjs(_vm.board.createdAt).format("YYYY-MM-DD HH:mm:ss")))])], 1)], 1), _c('v-divider'), _c('v-card-text', {
    staticClass: "font-size-14"
  }, [_c('v-responsive', {
    attrs: {
      "min-height": "400"
    }
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.board.content)
    }
  })])], 1)], 1)], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }